import createLabelComponent from "../../../../helpers/common/CoreInputText/components/Label/fabric";
import { INPUT_TEXTAREA_DISPLAY_NAME } from "../../utils/core";

export const Component = createLabelComponent(INPUT_TEXTAREA_DISPLAY_NAME);
export default Component;
